enum ActionSelectionOptions {
	NONE = 0,
	FIND_OR_EDIT_USER = 1,
	ADD_NEW_USER = 2
}

export { ActionSelectionOptions };
